export default "__VITE_ASSET__2fbd1282__"